import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";

import axios from "axios";
import TreeView from "./TreeView";
import EditUser from "./EditUser";
import tableBg from "../../Assets/Images/Rectangle.svg"
import { use } from "react";
import { postData } from "../../resources/utils";

const ApprovedReq = ({ approvedUserListData, handleSetUserForm, setUserDetailFn, updateUserListData, handleSearchInputChange,searchInput }) => {
  const [approveRejectUser, setApproveRejectUser] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [activeTab, setActiveTab] = useState("Pending");
  const [viewUserForm, setViewUserForm] = useState(false);
  const [addNewUserForm, setAddNewUserForm] = useState(false);
  const [deleteUser, setDeleteUser] = useState(false);
  const [viewUser, setViewUser] = useState(false);
  const [viewEditModal, setEditModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [deletUserForm, setDeletUserForm] = useState(false)

  const decodeJWT = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  };

  useEffect(() => {
    setFilteredData(approvedUserListData);
  }, [approvedUserListData]);

  const openUserDetails = (user) => {
    if (activeTab === "Pending" || activeTab === "Approved") {
      setSelectedUser(user);
      handleSetUserForm(true);
      setUserDetailFn(user);
    }
  };

  const addUser = () => setAddNewUserForm(true);
  const closeAddUserForm = () => setAddNewUserForm(false);

  const deleteUserRequest = async (user) => {
    const adminId = Number(localStorage.getItem("user_id"));

const deleteUserPayload = {
    type: "delete_user",
    admin_id: adminId,
    user_id: user.id
}
    try {
       const userRes = await postData(
      "agribhumi",
      "add_user",   
      deleteUserPayload,
      null
    );
   console.log('useref',userRes);
      updateUserListData();
      setDeleteUser(false);
      closeDeleteUserModal()


    }
    catch (err) {
      console.log("error", err);

    }
  }

  const openDeleteUserModal = (user) => {
    setDeleteUser(true);
    setSelectedUser(user);
  };
  const closeDeleteUserModal = () => {
    setDeleteUser(false);
    setSelectedUser(null);
  };

  const openViewUserModal = (user) => {
    // console.log('user data in view modal', user);
    setSelectedUser(user);
    setViewUser(true);
    setSelectedUserId(user?.id);
  };
  const closeViewUserModal = () => {
    setViewUser(false);
    setSelectedUserId(null);
  };

  const openEditModal = (user) => {
    setEditModal(true);
    setSelectedUserId(user?.id);
    setSelectedUser(user);
  };
  const closeEditModal = () => {
    setEditModal(false);
    setSelectedUserId(null);
  };

  const openApproveRejectUserModal = (user) => {
    setApproveRejectUser(true);
    setSelectedUser(user);
  };
  const closeAppproveRejectUserModal = () => setApproveRejectUser(false);

 const approveUserRequest = async (user, status) => {
  if (!user?.id) {
    return;
  }

  try {
    setLoading(true);
    const approveRejectParam = {
      type: "update_user",
      admin_id: Number(localStorage.getItem("user_id")) || 0,
      user_id: Number(user?.id) || 0,
      user_status: Number(status) || 0,
    };

    const approveResp = await postData(
      "agribhumi",
      "user_status_change",
      approveRejectParam,
      null
    );

    if (approveResp?.status === 200) {
      setViewUserForm(false);
      setApproveRejectUser(false);
      setFilteredData(prev => prev.filter(u => u.id !== user.id));
      if (typeof updateUserListData === 'function') {
        updateUserListData();
      }
       else {
        // console.warn("updateUserListData is not a function or not passed as prop");
      }
      // console.log("User status updated successfully");
    } else {
      // console.log("API Error:", approveResp);
    }
  } catch (err) {
    console.log("error", err);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  if (!searchInput) {
    setFilteredData(approvedUserListData);
  } else {
    const filtered = approvedUserListData.filter(
      user =>
        (user?.name && user?.name.toLowerCase().includes(searchInput.toLowerCase())) ||
        (user?.mobileNo && String(user?.mobileNo).includes(searchInput)) ||
        (user?.email && user?.email.toLowerCase().includes(searchInput.toLowerCase()))
    );
    setFilteredData(filtered);
  }
}, [approvedUserListData, searchInput]);

  return (
  <>
<div className="bg-white w-[97%] m-auto overflow-hidden">

        <div className="max-h-[60vh] overflow-y-auto">
  <table className="w-full table-fixed">
    
    <thead className="bg-[#f5f5f5] sticky top-0 z-10">
      <tr className="h-[70px]">
        <th className="w-[20%] text-left px-6 text-[#000] text-[18px] font-semibold">Name</th>
        <th className="w-[20%] text-left px-6 text-[#000] text-[18px] font-semibold">Mobile No</th>
        <th className="w-[20%] text-left px-6 text-[#000] text-[18px] font-semibold">Email</th>
        <th className="w-[20%] text-left px-6 text-[#000] text-[18px] font-semibold">Login Counts</th>
        <th className="w-[20%] text-left px-6 text-[#000] text-[18px] font-semibold">Action</th>
        <th className="w-[20%] text-left px-6 text-[#000] text-[18px] font-semibold">Approved On</th>
      </tr>
    </thead>

    <tbody>
      {filteredData.map((row, index) => (
        <tr key={index} className="border-b border-gray-200 hover:bg-[#f1f1f1]">
          
          <td className="w-[20%] px-6 py-3 text-[#818589] text-[16px]">{row.name ?? "--"}</td>
          <td className="w-[20%] px-6 py-3 text-[#818589] text-[16px]">{row.mobileNo ?? "--"}</td>
          <td className="w-[20%] px-6 py-3 text-[#818589] text-[16px]">{row.email ?? "--"}</td>
          <td className="w-[20%] px-6 py-3 text-[#818589] text-[16px]">{row?.logins_count ?? "--"}</td>
          <td className="w-[20%] px-6 py-3">
            <div className="flex  gap-3">
              <div className="relative group inline-block">

                <svg onClick={() => openViewUserModal(row)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 cursor-pointer hover:border hover:border-white">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                      View user access
                    </span>
              </div>
              <div className="relative group inline-block">

                <svg onClick={() => openEditModal(row)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 cursor-pointer hover:border hover:border-white">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                </svg>
                 <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                      Edit user access
                    </span>
              </div>
              <div className="relative group inline-block">

                <svg onClick={() => openApproveRejectUserModal(row)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 cursor-pointer hover:border hover:border-white">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                </svg>
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                      Dis-Approve user
                    </span>
              </div>
              <div className="relative group inline-block">

                <svg onClick={() => row.id != decodeJWT(localStorage.getItem("token"))['sub'] && openDeleteUserModal(row)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`size-6 cursor-pointer hover:border ${row.id == decodeJWT(localStorage.getItem("token"))['sub'] ? 'text-gray-500 cursor-not-allowed' : 'hover:border-white'}`}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                </svg>
                <span className={`absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50 ${row.id == decodeJWT(localStorage.getItem("token"))['sub'] ? 'hidden' : ''}`}>
                      Delete user
                    </span>
              </div>
            </div>
                </td>

          <td className="w-[20%] px-6 py-3 text-[#818589] text-[16px]">
            {row?.approved_on
              ? (() => {
                  const d = new Date(row.approved_on.replace(" ", "T"));
                  return isNaN(d.getTime()) ? "-" : d.toLocaleString();
                })()
              : "-"}
          </td>

        </tr>
      ))}
    </tbody>

  </table>
</div>
      </div>

      {addNewUserForm && (
        <div className="z-[1000000] bg-[#00000066] h-[100vh] w-[calc(100vw-85px)] absolute top-0 overflow-hidden">
          <div className="modal-overlay w-[60%] bg-[#212529] z-[1000] relative top-[10%] ml-[18%]">
            <div className="modal-content z-[1001]">
              <div className="bg-[#000000] pt-[1%]">
                <span
                  onClick={closeAddUserForm}
                  className="close-button cursor-pointer text-white text-[30px] flex justify-end mr-[3%]"
                >
                  &times;
                </span>
                <div className="text-center">
                  <p className="text-[#ffffff] text-[35px] font-bold">Edit Access Level</p>
                  <p className="text-[#ffffff] text-[18px] font-normal">
                    You Can Edit And View The Role Assigned To The Users.
                  </p>
                </div>
              </div>

              <div className="mt-[1%] w-[92%] ml-[4%]">
                {["Name", "Mobile Number", "Email", "Department", "Designation"].map((label, idx) => (
                  <div className="flex items-baseline justify-start p-[1%] mt-[1%]" key={idx}>
                    <div className="w-[40%]">
                      <p className="text-[#ffffff] text-[16px] font-normal">{label}</p>
                    </div>
                    <div className="w-[40%]">
                      <input
                        type="text"
                        className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] focus:outline-none p-4"
                      />
                    </div>
                  </div>
                ))}

                {["Division", "District", "Block", "Gram Panchayat", "Permission To Download"].map(
                  (label, idx) => (
                    <div className="flex items-baseline pt-[1%] mt-[1%] justify-start" key={idx}>
                      <div className="w-[40%]">
                        <p className="text-[#ffffff] text-[16px] font-normal">{label}</p>
                      </div>
                      <div>
                        <Select
                          placeholder={
                            <div className="text-xs">
                              {getString(label.toUpperCase(), chosenLang)} {getString("SELECT", chosenLang)}
                            </div>
                          }
                          className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] focus:outline-none"
                          isClearable
                          isMulti
                        />
                      </div>
                    </div>
                  )
                )}

                <div className="flex p-[1%] mt-[5%] justify-center">
                  <button className="bg-[#ED1849] text-[#FFFFFF] w-[123px] h-[44px]">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

       {/* --------------------------------------section for approve or reject ----------------------------- */}
    {approveRejectUser && (
  <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">
    
    <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col relative">

      {/* Close Button */}
      <span
        onClick={closeAppproveRejectUserModal}
        className="absolute top-2 right-4 cursor-pointer text-white text-[28px] font-bold z-10"
      >
        &times;
      </span>

      {/* Header */}
      <div
        className="flex  items-center px-6 h-[80px]"
        style={{
          backgroundImage: `url(${tableBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }}
      >
        <p className="text-[#ffffff] text-[28px] font-bold text-center mt-[4%]">
          Disapprove the User
        </p>
      </div>

      {/* Body */}
      <div className="flex flex-col items-center justify-center py-6 px-4">
        
        <p className="text-black text-[16px] text-center mb-6">
          Do you want to dis-approve
        </p>
        <div className="flex justify-center gap-4">
          <button
            className="bg-[#2f9ce6] text-white w-[123px] h-[44px] rounded-md"
            onClick={() => approveUserRequest(selectedUser, "0")}
          >
            Yes
          </button>

          <button
            className="border border-[#2f9ce6] text-[#2f9ce6] w-[123px] h-[44px] rounded-md"
            onClick={closeAppproveRejectUserModal} >No</button>
        </div>
      </div>
    </div>
  </div>
)}



     {/* modal for delete user  */}
      {deleteUser && (
  <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">
    
    <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col relative">

      {/* Close Button */}
      <span
        onClick={closeDeleteUserModal}
        className="absolute top-2 right-4 cursor-pointer text-white text-[28px] font-bold z-10"
      >
        &times;
      </span>

      {/* Header */}
      <div
        className="flex items-center px-6 h-[80px]"
        style={{
          backgroundImage: `url(${tableBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }}
      >
        <p className="text-[#ffffff] text-[28px] font-bold text-center mt-[4%]">
          Delete User
        </p>
      </div>

      {/* Body */}
      <div className="flex flex-col items-center justify-center py-6 px-4">
        
        <p className="text-black text-[16px] text-center mb-6">
          Do you want to delete the user
        </p>

        <div className="flex justify-center gap-4">
          <button
             className="bg-[#2f9ce6] text-white w-[123px] h-[44px] rounded-md"
            onClick={() => deleteUserRequest(selectedUser)}
          >
            Confirm
          </button>

          <button
            className="border border-[#2f9ce6] text-[#2f9ce6] w-[123px] h-[44px] rounded-md"
            onClick={closeDeleteUserModal}
          >
            Cancel
          </button>
        </div>

      </div>
    </div>
  </div>
)}


      {/* modal for view user */}

          {viewUser && (
        <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">
          <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col">

            {/* Header */}
            <div
              className="flex justify-between items-center px-6 h-[80px]"
              style={{
                backgroundImage: `url(${tableBg})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover"
              }}
            >
              <p className="text-white text-[26px] font-semibold m-0">
                View User Access
              </p>

              <span
                onClick={closeViewUserModal}
                className="text-white text-[28px] cursor-pointer"
              >
                &times;
              </span>
            </div>
  <div className="px-6 py-3 bg-gray-100 border-b">
              <p className="text-black text-[18px] font-semibold">
                {selectedUser?.name}
              </p>
              <p className="text-gray-700 text-[18px]">
                📱 {selectedUser?.mobileNo}
              </p>
              <p className="text-gray-500 text-[18px]">
                {selectedUser?.email}
              </p>
            </div>
            {/* Content */}
            <div className="p-4 max-h-[400px] overflow-y-auto">
              <TreeView selectedUserId={selectedUserId} selectedUserData={selectedUser} />
            </div>

          </div>
        </div>
      )}

      {/* end of view user modal */}


      {/* modal for view user */}

{viewEditModal && (
  <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">

    <div className="w-[80%] max-w-[600px] max-h-[90vh] rounded-lg shadow-lg bg-white flex flex-col relative">

      <div
        className="flex items-center justify-between px-6 h-[80px] shrink-0"
        style={{
          backgroundImage: `url(${tableBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }}
      >
        <p className="text-white text-[22px] font-semibold">
          Edit User Access
        </p>

        <span
          onClick={closeEditModal}
          className="text-white text-[26px] cursor-pointer hover:scale-110 transition"
        >
          ×
        </span>
      </div>

      {/* Body */}
      <div className="p-4 overflow-y-auto flex-1">
        <EditUser
          selectedUserId={selectedUserId}
          closeEditModal={closeEditModal}
          selectedUserData={selectedUser}
        />
      </div>

    </div>
  </div>
)}
    </>
  );
};

export default ApprovedReq;